export default __webpack_public_path__ + "static/media/b1.70aab7e4.jpg";